import { SITE, TASK_SETTING_OPTION } from '@/app/constants';

// 滑块图片资源
export const THUMB_SRC =
  SITE === 'china'
    ? 'https://image01-aliyun.vidu.zone/vidu/media-asset/slide_thumb-306183f9.webp'
    : 'https://image01.cf.vidu.studio/vidu/media-asset/slide_thumb-306183f9.webp';

// 样式常量
export const SLIDER_STYLES = {
  container: 'relative flex w-full select-none items-center',
  track: 'relative h-full w-full grow cursor-pointer overflow-hidden rounded-8',
  trackBackground: 'absolute inset-0 rounded-8 bg-transparent',
  range: {
    base: 'absolute h-full rounded-8 border border-system-white bg-system-white24 transition-colors cursor-grab active:cursor-grabbing touch-manipulation',
    dragging: 'cursor-grabbing bg-system-white32',
    disabled: 'cursor-not-allowed',
  },
  thumb: {
    base: 'custom-thumb absolute top-0 h-full cursor-grab active:cursor-grabbing touch-manipulation',
    dragging: 'cursor-grabbing',
    disabled: 'cursor-not-allowed',
  },
} as const;

export const SETTING_KEY_CONFIG: TASK_SETTING_OPTION[] = [
  TASK_SETTING_OPTION.ExtendModalVersion,
  TASK_SETTING_OPTION.Duration,
  TASK_SETTING_OPTION.Resolution,
  TASK_SETTING_OPTION.Amount,
];
